import React from 'react';
import { TextOverlay } from 'blocks/TextOverlayModal';
import { TextOverlayV2 } from 'blocks/TextOverlayModal/v2';
import { ActiveModal } from 'blocks/TextOverlaySwitchModal';

import { useTemplateState } from '../../context/VideoTemplateStateContext';
import TextAssetLegacyModal, {
  TextAssetLegacyModalProps,
} from './TextAssetLegacyModal';
import TextAssetModal, { TextAssetModalProps } from './TextAssetModal';

export type TextAssetModalType = 'add' | 'edit';

export type PickedTextAssetLegacyModalProps = Pick<
  TextAssetLegacyModalProps,
  | 'banner'
  | 'defaultText'
  | 'editable'
  | 'onCancel'
  | 'onDelete'
  | 'onExited'
  | 'onSubmit'
  | 'show'
  | 'showEmoji'
  | 'textOverlay'
  | 'title'
>;

export interface TextAssetModalBaseProps {
  onSwitchModal?: (
    target: ActiveModal,
    onHide: () => void,
  ) => (partialOverlay?: TextOverlay | TextOverlayV2) => Promise<void>;
}

export interface TextAssetModalWrapperLegacyModeProps
  extends TextAssetModalBaseProps,
    PickedTextAssetLegacyModalProps {
  assetId: string;
  isLegacy: true;
  type: TextAssetModalType;
}

export type PickedTextAssetModalProps = Pick<
  TextAssetModalProps,
  | 'defaultText'
  | 'editable'
  | 'onCancel'
  | 'onDelete'
  | 'onExited'
  | 'onSubmit'
  | 'show'
  | 'showEmoji'
  | 'subTitle'
  | 'textOverlay'
  | 'title'
>;

export interface TextAssetModalWrapperNonLegacyModeProps
  extends TextAssetModalBaseProps,
    PickedTextAssetModalProps {
  assetId: string;
  isLegacy: false;
  isV2CompatibilityMode: boolean;
  type: TextAssetModalType;
}

export type TextAsseModalWrapperProps =
  | TextAssetModalWrapperLegacyModeProps
  | TextAssetModalWrapperNonLegacyModeProps;

const TextAssetModalWrapper: React.FunctionComponent<TextAsseModalWrapperProps> = props => {
  const {
    defaultText,
    editable = true,
    assetId,
    isLegacy,
    onCancel,
    onDelete,
    onExited,
    onSubmit,
    onSwitchModal,
    show,
    showEmoji = true,
    textOverlay,
    title,
    type,
  } = props;

  const state = useTemplateState();
  const { aspectRatio, backgroundColor } = state;

  const isEdit = type === 'edit';

  // explicit check with true allow a proper type inference when the if
  // condition is not met.
  if (isLegacy === true) {
    const { banner } = props;

    return (
      <TextAssetLegacyModal
        {...{
          assetId,
          aspectRatio,
          backgroundColor,
          banner,
          defaultText,
          editable,
          isEdit,
          onCancel,
          onDelete,
          onExited,
          onSwitchToCurrentModal: onSwitchModal?.('current', onCancel),
          onSubmit,
          show,
          showEmoji,
          textOverlay,
          title,
        }}
      />
    );
  }

  const { isV2CompatibilityMode, subTitle } = props;

  return (
    <TextAssetModal
      {...{
        aspectRatio,
        assetId,
        backgroundColor,
        defaultText,
        editable,
        isEdit,
        isV2CompatibilityMode,
        onCancel,
        onDelete,
        onExited,
        onSwitchToLegacyModal: onSwitchModal?.('legacy', onCancel),
        onSubmit,
        show,
        showEmoji,
        subTitle,
        textOverlay,
        title,
      }}
    />
  );
};

export default TextAssetModalWrapper;
